var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoListBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 50,
    viewBox: "0 0 44 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6214 0L43.2429 12.5V37.5L21.6214 50L0 37.5V12.5L21.6214 0Z",
    fill: "#1C2743"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.625 24.625C27.625 24.9565 27.4933 25.2745 27.2589 25.5089C27.0245 25.7433 26.7065 25.875 26.375 25.875L12.625 25.875C12.2935 25.875 11.9755 25.7433 11.7411 25.5089C11.5067 25.2745 11.375 24.9565 11.375 24.625C11.375 24.2935 11.5067 23.9755 11.7411 23.7411C11.9755 23.5067 12.2935 23.375 12.625 23.375L26.375 23.375C26.7065 23.375 27.0245 23.5067 27.2589 23.7411C27.4933 23.9755 27.625 24.2935 27.625 24.625ZM32.625 15.875C32.625 16.2065 32.4933 16.5245 32.2589 16.7589C32.0245 16.9933 31.7065 17.125 31.375 17.125L12.625 17.125C12.2935 17.125 11.9755 16.9933 11.7411 16.7589C11.5067 16.5245 11.375 16.2065 11.375 15.875C11.375 15.5435 11.5067 15.2255 11.7411 14.9911C11.9755 14.7567 12.2935 14.625 12.625 14.625L31.375 14.625C31.7065 14.625 32.0245 14.7567 32.2589 14.9911C32.4933 15.2255 32.625 15.5435 32.625 15.875ZM22.625 33.375C22.625 33.7065 22.4933 34.0245 22.2589 34.2589C22.0245 34.4933 21.7065 34.625 21.375 34.625L12.625 34.625C12.2935 34.625 11.9755 34.4933 11.7411 34.2589C11.5067 34.0245 11.375 33.7065 11.375 33.375C11.375 33.0435 11.5067 32.7255 11.7411 32.4911C11.9755 32.2567 12.2935 32.125 12.625 32.125L21.375 32.125C21.7065 32.125 22.0245 32.2567 22.2589 32.4911C22.4933 32.7255 22.625 33.0435 22.625 33.375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoListBox);
export default __webpack_public_path__ + "static/media/ico-list-box.74ffdbfff98a17f86706490351e216b8.svg";
export { ForwardRef as ReactComponent };